import { render } from "./PostponeModal.vue?vue&type=template&id=54e013b2&scoped=true"
import script from "./PostponeModal.vue?vue&type=script&lang=js"
export * from "./PostponeModal.vue?vue&type=script&lang=js"

import "./PostponeModal.vue?vue&type=style&index=0&id=54e013b2&scoped=true&lang=less"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e013b2"]])

export default __exports__